import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';
import { useIsMailboxSyncInProgress } from '@/contexts/userContext/MailboxSync.context.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

export const TopBarMailboxSyncIndicator: React.FC = () => {
  const { t } = useTranslationWithPrefix('topBar.mailboxSync');
  const isSyncInProgress = useIsMailboxSyncInProgress();

  if (!isSyncInProgress) {
    return null;
  }

  return (
    <Tooltip title={t('tooltip')}>
      <Stack direction="row" role="status" spacing={1} sx={{ alignItems: 'center' }}>
        <CircularProgress size={14} sx={{ color: themeColors.accentColor }} />
        <Typography sx={{ color: themeColors.greyDarker }} variant="f14Regular">
          {t('label')}
        </Typography>
      </Stack>
    </Tooltip>
  );
};
